import { injectReducer } from '../../store/reducers'
import Home from '../HomeAdmin'
import AddPatientRoute from '../AddPatient'
import PatientDetailRoute from '../PatientDetail'
import DoctorDetailRoute from '../DoctorDetail'
import PatientAdmin from '../PatientAdmin'
import PatientDetailAdmin from '../PatientDetailAdmin'
import Setting from '../SettingAdmin'
import Test from '../Test'
import Signup from '../Signup'
import {userInfo} from './modules/main'
export default (store) => ({
  path : '',
  childRoutes: [
    Home(store),
    AddPatientRoute(store),
    PatientDetailRoute(store),
    DoctorDetailRoute(store),
    PatientAdmin(store),
    Setting(store),
    Test(store),
    Signup(store)
  ],
  getComponent (nextState, cb) {
    require.ensure([
        './containers/MainContainer',
        './modules/main'
      ], (require) => {
      const Main = require('./containers/MainContainer').default
      const reducer = require('./modules/main').default
      injectReducer(store, { key: 'main', reducer });
      store.dispatch(userInfo())
      cb(null, Main)
    }, 'main')
  }
})


// WEBPACK FOOTER //
// ./src/routes/MainAdmin/index.js